<svg-icon src="assets/images/icons/{{ type() }}.svg"></svg-icon>
@if (firewallEnabled()) {
  <span class="overlap">
    <svg-icon src="assets/images/icons/fw-overlap.svg"></svg-icon>
  </span>
}
